import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { LocaleService, WindowProxy } from '@sm360/widget-commons-core-services';
import { Vehicle, PurchaseMethods } from '@sm360/widget-commons-vehicle';

import PaymentCalculatorDisplay from 'payment-calculator/components/PaymentCalculatorDisplay/PaymentCalculatorDisplay.jsx';
import * as Actions from 'payment-calculator/actions/paymentCalculatorActions.js';
import 'payment-calculator/components/PaymentCalculator/paymentCalculator.scss';

const $window = WindowProxy.get();
class PaymentCalculator extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isPanelOpen: false,
        };

        this.handleFrequenciesPanel = this.handleFrequenciesPanel.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleOutsideClick = this.handleOutsideClick.bind(this);
    }

    handleFrequenciesPanel() {
        this.setState(
            (prevState) => {
                return { isPanelOpen: !prevState.isPanelOpen };
            },
            function() {
                if ($window) {
                    $window.document.body.classList.toggle('PaymentCalculator--open', this.state.isPanelOpen);
                }
            }
        );
    }

    handleClick() {
        if ($window) {
            if (!this.state.isPanelOpen) {
                this.props.onOpen();
                $window.document.addEventListener('click', this.handleOutsideClick, false);

                const { purchaseMethods } = this.props;
                this.props.actions.selectPurchaseMethod(purchaseMethods.getSelectedPurchaseMethod());
            } else {
                this.props.onClose();
                $window.document.removeEventListener('click', this.handleOutsideClick, false);
            }

            if (this.state.isPanelOpen && this.props.tradeInVehicle && this.props.tradeInVehicle.checkIsUpdatable()) {
                this.props.actions.saveTradeInVehicle(this.props.tradeInVehicle);
            }

            this.handleFrequenciesPanel();
        }
    }

    handleOutsideClick(e) {
        if (this.node.contains(e.target)) {
            return;
        }

        this.handleClick();
    }

    render() {
        const frequenciesPanelClasses = ['frequencies-panel-wrapper', 'sr-paymentCalculator-Panelbackground'];

        if (this.state.isPanelOpen) {
            frequenciesPanelClasses.push('is-open');
        }

        const setPaymentLabel = !this.state.isPanelOpen
            ? 'PAYMENT_CALCULATOR.SET_PAYMENT'
            : 'PAYMENT_CALCULATOR.SAVE_PAYMENT';
        const iconPanel = !this.state.isPanelOpen ? 'icon-calculatrice' : 'icon-Crochet';

        const customButton = this.props.hasCustomButton && (
            <button className="calculator-btn sr-text is-util" onClick={this.handleClick}>
                <icon className={iconPanel} />
                <span className="is-small is-bold">{LocaleService.t(setPaymentLabel)}</span>
            </button>
        );

        const wrapperClasses = ['payment-calculator-wrapper'];
        if (this.state.isPanelOpen) {
            wrapperClasses.push('is-open');
        }

        return (
            <div
                className={wrapperClasses.join(' ')}
                ref={(node) => {
                    this.node = node;
                }}
            >
                {customButton}
                <PaymentCalculatorDisplay
                    {...this.props}
                    panelFrequenciesClassNames={frequenciesPanelClasses}
                    handleFrequenciesPanel={this.handleClick}
                    frequenciesPanelOpen={this.state.isPanelOpen}
                    hasCustomButton={this.props.hasCustomButton}
                />
            </div>
        );
    }
}

PaymentCalculator.defaultProps = {
    purchaseMethods: new PurchaseMethods.PurchaseMethodsModel(),
    hasCustomButton: false,
    tradeInVehicle: null,
    onClose: noop,
    onOpen: noop,
};

PaymentCalculator.propTypes = {
    purchaseMethods: PropTypes.instanceOf(PurchaseMethods.PurchaseMethodsModel),
    onClose: PropTypes.func,
    onOpen: PropTypes.func,
    hasCustomButton: PropTypes.bool,
    tradeInVehicle: PropTypes.instanceOf(Vehicle.TradeInVehicleModel),
    actions: PropTypes.shape({
        saveTradeInVehicle: PropTypes.func.isRequired,
        selectPurchaseMethod: PropTypes.func.isRequired,
    }),
};

function mapStateToProps(state) {
    return {
        tradeInVehicle: state.tradeInVehicle,
        purchaseMethods: state.purchaseMethods,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    };
}

PaymentCalculator.displayName = 'PaymentCalculator';

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PaymentCalculator);
export { PaymentCalculator };



// WEBPACK FOOTER //
// ./src/components/PaymentCalculator/PaymentCalculator.jsx